import React, {
  useContext,
} from 'react';
import CheckoutPageContext from '../../context/CheckoutPageContext';
import { useIsL } from '../../hooks/useBreakPoint';
import Footer from '../Common/Footer/Footer';

export default function FooterRightRailWrapper() {
  const isLBreakPoint = useIsL();

  const {
    checkoutPageState,
  } = useContext(CheckoutPageContext);

  // Only show footer on mobile/responsive view (screens smaller than L breakpoint)
  if (!isLBreakPoint) { return null; }

  return (
    <div className="footer-right-rail-wrapper">
      {checkoutPageState?.textFor && (
        <div className="checkout-right-rail-footer" data-testid="checkout-right-rail-footer">
          <Footer
            orderId={checkoutPageState?.orderTotals?.orderId}
            tmntData={checkoutPageState?.textFor}
            phoneNumberByCountry={checkoutPageState?.footer?.phoneNumberByCountry}
            phoneNumberByLanguage={checkoutPageState?.footer?.phoneNumberByLanguage}
            page={checkoutPageState?.page}
          />
        </div>
      )}
    </div>
  );
}

FooterRightRailWrapper.defaultProps = {
};

FooterRightRailWrapper.propTypes = {
};
